// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 571 ? "ff273499" : chunkId) + "." + {"525":"3424e7cac95f0230","571":"d9ee8c4d0a8d15c1"}[chunkId] + ".js";
};